<template>
  <div class="active">
    <div class="row align-items-stretch">
      <div class="col section__acceleration-description mb-5">
        <div class="section__acceleration-description-text mb-5">
          <p>Новый уникальный продукт, направленный на индивидуальную проработку экспортного проекта компании совместно с наставником Школы экспорта РЭЦ!</p>
          <p>С нашими наставниками вы выведете свой экспорт на новый уровень. По результатам получения услуги до 90% компаний заключают экспортный контракт.*</p>
          <div class="item-description mb-24 text-danger">
            * в случае, если компания прошла все три этапа услуги
          </div>
        </div>
        <h2 class="mb-4">
          Для кого услуга?
        </h2>
        <div class="section__acceleration-description-text mb-4">
          <p>Потенциальные и действующие компании-экспортеры, имеющие в наличии готовый продукт для экспорта (товарные категории).</p>
        </div>
      </div>
      <div class="col-md-4 mb-3 mb-md-0 section__acceleration-tag">
        <div class="container-shadow p-24 fill-white">
          <div class="section__acceleration-tag-img mb-24">
            <img src="/pic/export-incease.png" class="object-fit-cover"/>
          </div>
          <div class="section__acceleration-tag-title">
            Мы подготовим для вашей компании индивидуальное коммерческое предложение!
          </div>
          <div><a href="#" @click.prevent="setRole('ROLE_CRM_MENTORING_CLIENT_REQUEST')" class="link-target"><span>запросить</span></a></div>
        </div>
      </div>
    </div>
    <div class="section__acceleration-description-text mb-4">
      <h2 class="mb-4">
        Задачи экспортного наставничества
      </h2>

      <p>Услуга «Экспортное наставничество» решает несколько важных задач:</p>

      <p>Снижение рисков и издержек клиента</p>
      <ul>
        <li>выбор внешнего рынка с учетом потенциала экспортера</li>
        <li>соблюдение всех критериев при поиске партнера</li>
        <li>подготовка мероприятий по управлению рисками</li>
      </ul>

      <p>Расчет экономики вашего экспортного проекта</p>
      <ul>
        <li>определение объемов финансирования проекта</li>
        <li>определение оптимальных условий оплаты и поставки</li>
        <li>выстраивание эффективной логистики поставок</li>
      </ul>

      <p>Соблюдение обязательных норм и требований при экспорте. Мы поможем:</p>
      <ul>
        <li>выполнить требования экспортного контроля</li>
        <li>выполнить требования валютного законодательства</li>
        <li>учесть необходимые условия внешнеторгового контракта</li>
        <li>применить механизмы возврата валютного НДС и др.</li>
      </ul>
    </div>
    <div class="animated-container">
      <div class="section__subsection_blue section__acceleration-premise section__acceleration-premise-2">
        <div class="section__subsection-wrapper" style="padding-bottom: 12rem;">
          <div class="row align-items-end">
            <div class="col-sm-6">
              <h2 class="section__acceleration-premise-title">Уникальность продукта «Экспортное наставничество»</h2>
            </div>
            <div class="col-sm-6">
              <div class="section__acceleration-target-img section__acceleration-target-img_2">
                <img src="/pic/truks.jpg" class="object-fit-cover"/>
              </div>
            </div>
          </div>

          <div class="section__acceleration-premise-grid container-grid">
            <div class="container-grid__item">
              <div class="container-grid__item-wrapper">
                <svg width="72" height="72" viewBox="0 0 144 144" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M126.968 104.469C129.656 101.469 131.294 97.5114 131.294 93.1765C131.294 83.8351 123.694 76.2353 114.353 76.2353C105.012 76.2353 97.4118 83.8351 97.4118 93.1765C97.4118 97.5114 99.0503 101.469 101.738 104.469C97.9081 106.277 94.5258 108.881 91.8048 112.067L76.2353 99.6116V67.7647H101.647V55.0588C101.647 43.2203 94.6713 32.9819 84.615 28.2336C87.3027 25.2344 88.9412 21.2761 88.9412 16.9412C88.9412 7.59981 81.3414 0 72 0C62.6586 0 55.0588 7.59981 55.0588 16.9412C55.0588 21.2761 56.6973 25.2344 59.385 28.2336C49.3288 32.9819 42.3529 43.2203 42.3529 55.0588V67.7647H67.7647V99.6116L52.1946 112.067C49.4739 108.881 46.0916 106.277 42.2617 104.469C44.9497 101.469 46.5882 97.5114 46.5882 93.1765C46.5882 83.8351 38.9884 76.2353 29.6471 76.2353C20.3057 76.2353 12.7059 83.8351 12.7059 93.1765C12.7059 97.5114 14.3444 101.469 17.0321 104.469C6.97581 109.217 0 119.455 0 131.294V144H59.2941V131.294C59.2941 127.017 58.3824 122.95 56.7456 119.274L72 107.071L87.2541 119.274C85.6173 122.95 84.7059 127.017 84.7059 131.294V144H144V131.294C144 119.455 137.024 109.217 126.968 104.469ZM63.5294 16.9412C63.5294 12.2705 67.3293 8.47059 72 8.47059C76.6707 8.47059 80.4706 12.2705 80.4706 16.9412C80.4706 21.6119 76.6707 25.4118 72 25.4118C67.3293 25.4118 63.5294 21.6119 63.5294 16.9412ZM50.8235 55.0588C50.8235 43.3821 60.3233 33.8824 72 33.8824C83.6767 33.8824 93.1765 43.3821 93.1765 55.0588V59.2941H50.8235V55.0588ZM21.1765 93.1765C21.1765 88.5058 24.9764 84.7059 29.6471 84.7059C34.3177 84.7059 38.1176 88.5058 38.1176 93.1765C38.1176 97.8472 34.3177 101.647 29.6471 101.647C24.9764 101.647 21.1765 97.8472 21.1765 93.1765ZM50.8235 135.529H8.47059V131.294C8.47059 119.617 17.9704 110.118 29.6471 110.118C41.3238 110.118 50.8235 119.617 50.8235 131.294V135.529ZM105.882 93.1765C105.882 88.5058 109.682 84.7059 114.353 84.7059C119.024 84.7059 122.824 88.5058 122.824 93.1765C122.824 97.8472 119.024 101.647 114.353 101.647C109.682 101.647 105.882 97.8472 105.882 93.1765ZM135.529 135.529H93.1765V131.294C93.1765 119.617 102.676 110.118 114.353 110.118C126.03 110.118 135.529 119.617 135.529 131.294V135.529Z" fill="#fff"/>
                </svg>
                <h2>Комплексное сопровождение</h2>
                <div class="item-content">
                  Экспортный наставник сопровождает компанию на протяжении всех этапов реализации экспортного проекта
                </div>
              </div>
            </div>
            <div class="container-grid__item">
              <div class="container-grid__item-wrapper">
                <svg width="72" height="72" viewBox="0 0 144 144" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M116.559 53.5435C115.867 23.8998 91.5376 0 61.7305 0C31.4896 0 6.88672 24.6029 6.88672 54.8438C6.88672 70.0762 13.088 84.1854 23.7617 94.4024V144H82.8242V126.562H116.574V84.375H137.113L116.559 53.5435ZM108.137 75.9375V101.25H99.6992C95.0468 101.25 91.2617 97.4649 91.2617 92.8125H82.8242C82.8242 102.117 90.3943 109.688 99.6992 109.688H108.137V118.125H78.6055C70.0892 118.125 62.543 113.016 59.3803 105.109L57.2099 99.6832L49.376 102.817L51.5464 108.243C53.7179 113.672 57.4248 118.274 62.2668 121.552C65.9321 124.033 70.0605 125.627 74.3867 126.256V135.562H32.1992V90.6722C31.8013 90.1381 15.3242 78.1048 15.3242 54.8438C15.3242 29.2553 36.1421 8.4375 61.7305 8.4375C87.3189 8.4375 108.137 29.2553 108.137 54.8438V56.1212L121.348 75.9375H108.137Z" fill="#fff"/>
                  <path d="M61.7305 25.3125C45.4469 25.3125 32.1992 38.5602 32.1992 54.8438C32.1992 71.1273 45.4469 84.375 61.7305 84.375C78.014 84.375 91.2617 71.1273 91.2617 54.8438C91.2617 38.5602 78.014 25.3125 61.7305 25.3125ZM61.7305 75.9375C50.0994 75.9375 40.6367 66.4748 40.6367 54.8438C40.6367 43.2127 50.0994 33.75 61.7305 33.75C73.3616 33.75 82.8242 43.2127 82.8242 54.8438C82.8242 66.4748 73.3616 75.9375 61.7305 75.9375Z" fill="#fff"/>
                  <path d="M57.5117 57.3149L52.0575 51.8604L46.0913 57.8268L57.5117 69.2472L77.37 49.3893L71.4038 43.4229L57.5117 57.3149Z" fill="#fff"/>
                </svg>
                <h2>Краудсорсинговая модель работы</h2>
                <div class="item-content">
                  К решению сложных узкоспециализированных вопросов компании привлекаются другие экспортные наставники (работает команда)
                </div>
              </div>
            </div>
            <div class="container-grid__item">
              <div class="container-grid__item-wrapper">
                <svg width="72" height="72" viewBox="0 0 144 144" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M131.069 21.1765C129.761 9.01158 122.888 0 114.353 0C105.818 0 98.9452 9.01158 97.6374 21.1765H88.7153C87.4077 9.01158 80.535 0 72 0C63.465 0 56.5923 9.01158 55.2844 21.1765H46.3624C45.0548 9.01158 38.1823 0 29.6471 0C21.1118 0 14.2393 9.01158 12.9315 21.1765H0V144H144C144 139.287 144 25.5795 144 21.1765H131.069ZM114.353 8.47059C117.743 8.47059 121.473 13.6808 122.529 21.1765H106.176C107.233 13.6808 110.962 8.47059 114.353 8.47059ZM72 8.47059C75.3905 8.47059 79.1201 13.6808 80.1764 21.1765H63.8233C64.8799 13.6808 68.6095 8.47059 72 8.47059ZM29.6471 8.47059C33.0376 8.47059 36.7672 13.6808 37.8234 21.1765H21.4704C22.527 13.6808 26.2566 8.47059 29.6471 8.47059ZM135.529 135.529H8.47059V67.7647H135.529V135.529ZM8.47059 59.2941V29.6471H37.8234C36.7672 37.1427 33.0376 42.3529 29.6471 42.3529V50.8235C38.1823 50.8235 45.0548 41.812 46.3624 29.6471H80.1764C79.1201 37.1427 75.3905 42.3529 72 42.3529V50.8235C80.535 50.8235 87.4077 41.812 88.7153 29.6471H122.529C121.473 37.1427 117.743 42.3529 114.353 42.3529V50.8235C122.888 50.8235 129.761 41.812 131.069 29.6471H135.529V59.2941H8.47059Z" fill="#fff"/>
                  <path d="M72.7218 91.0497L97.647 116.397L117.847 92.5242L118.631 98.0106L127.017 96.8128L124.45 78.8447L106.482 76.2776L105.284 84.6635L112.527 85.698L97.1772 103.838L72.0554 78.2913L53.8643 101.126L60.4894 106.404L72.7218 91.0497Z" fill="#fff"/>
                  <path d="M16.9409 101.647H42.3527V110.118H16.9409V101.647Z" fill="#fff"/>
                  <path d="M16.9409 84.7058H42.3527V93.1764H16.9409V84.7058Z" fill="#fff"/>
                  <path d="M16.9409 118.588H42.3527V127.059H16.9409V118.588Z" fill="#fff"/>
                </svg>
                <h2>Конверсия</h2>
                <div class="item-content">
                  До 90% компаний заключают экспортный контракт
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import setMentoringRoleMixin from "@/mixins/setMentoringRoleMixin";
import $ from 'jquery';
import '@fancyapps/fancybox/dist/jquery.fancybox.min.css'
window.jQuery = $

export default {
  name: "AboutMentoring",
  mixins: [setMentoringRoleMixin],
  mounted() {
    require('@fancyapps/fancybox')
    $('[data-fancybox]').fancybox({
      video: {
        tpl:
            '<video class="fancybox-video" controls controlsList="nodownload" poster="{{poster}}">' +
            '<source src="{{src}}" type="{{format}}" />' +
            "</video>",
        format: "", // custom video format
        autoStart: true
      },
    });
  }
}
</script>

<style scoped>
.preview-video {
  height: 50rem;
  background-size: contain;
}
</style>